// extracted by mini-css-extract-plugin
export default {"dateSeparator":"ChatRoomMessageList_dateSeparator__SWJSl"};